
import Vue from 'vue'
import BreadcrumbComponent from '@/components/Breadcrumb.vue'

export default Vue.extend({
   name: 'SchoolBreadcrumbComponent',
   props: {
      crumbs: { type: Array as () => Breadcrumb[], default: () => [] },
      includeSchool: { type: Boolean, default: true },
   },
   computed: {
      selectedSchool(): ISchool {
         return this.$store.getters.selectedSchool
      },
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },

      schoolId(): string {
         return this.selectedSchool ? (this.selectedSchool.Id as string) : ''
      },

      schoolName(): string {
         return this.selectedSchool ? this.selectedSchool.Name : 'School'
      },

      expandedCrumbs(): Breadcrumb[] {
         const crumbs = []
         if (
            this.userIsiUgoAdmin &&
            !this.containsCrumb('School Index') &&
            !this.containsCrumb('Home')
         ) {
            if (this.includeSchool) {
               crumbs.push({ text: 'School Index', route: 'home', params: {} })
            } else {
               crumbs.push({ text: 'Home', route: 'home', params: {} })
            }
         }
         if (this.includeSchool && !this.containsRoute('school-menu')) {
            crumbs.push({
               text: this.schoolName,
               route: 'school-menu',
               params: { schoolId: this.schoolId },
            })
         }
         crumbs.push(...this.crumbs)
         return crumbs
      },
   },
   methods: {
      containsCrumb(text: string) {
         const match = this.crumbs.find(c => c.text === text)
         return !!match
      },
      containsRoute(route: string) {
         const match = this.crumbs.find(c => c.route === route)
         return !!match
      },
   },
   components: {
      Breadcrumb: BreadcrumbComponent,
   },
})
